import { formatText } from 'core/i18n';
import { FUNDS_ORIGINS, FUNDS_ORIGINS_USER_PROFILE_KEYS } from 'components/FundsOriginDeclaration/constants';
import React from 'react';

const getFundsOriginOption = (fundsOrigin, onChange) => {
    return {
        label: formatText(`field-${FUNDS_ORIGINS_USER_PROFILE_KEYS[fundsOrigin]}`),
        model: `userProfile.${FUNDS_ORIGINS_USER_PROFILE_KEYS[fundsOrigin]}`,
        onChange(value) {
            onChange(fundsOrigin, value);
        },
        errorMessageComponent: <></>,
    };
};

export const getFundsOriginsOptions = onChange => {
    return [
        getFundsOriginOption(FUNDS_ORIGINS.BENEFITS, onChange),
        getFundsOriginOption(FUNDS_ORIGINS.PRIVATE_LOANS, onChange),
        getFundsOriginOption(FUNDS_ORIGINS.FINANCIAL_INVESTMENTS, onChange),
        getFundsOriginOption(FUNDS_ORIGINS.REAL_STATE_INVESTMENTS, onChange),
    ];
};
